import React from 'react';
import { Box, Button, Grid } from '@material-ui/core';
import { Link as RouterLink, useRouteMatch } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import { useTranslation } from 'react-i18next';
import { EmployeeList } from '../../modules/employee';
import { Method } from '../../routePaths';
import { PaddedContainer } from '../../ui-kit';


const EmployeeListView = () => {
    const { url } = useRouteMatch();
    const { t } = useTranslation();
    return (
        <PaddedContainer spacing={3}>
            <Grid item xs={12}>
                <Box mb={2} display="flex" justifyContent="flex-end">
                    <Button
                        startIcon={<AddIcon />}
                        component={RouterLink}
                        to={`${url}${Method.CREATE}`}
                        variant="contained"
                        color="primary"
                    >
                        {t('New employee')}
                    </Button>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <EmployeeList />
            </Grid>
        </PaddedContainer>
    );
};


export default EmployeeListView;
